import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { DatePicker, Radio, Select } from 'antd'
import Modal from 'react-bootstrap/Modal'
import { Formik } from 'formik'
import { Form, Checkbox } from 'formik-antd'
import TemplateMng from './TemplateMng'
import DraggableModalDialog from '../common/DraggableModalDialog'
import _ from 'lodash'
import SelectCompAntd from '../common/SelectCompAntd'
import * as templatesActions from '../../_actions/template.actions'
import * as biznumbersActions from '../../_actions/biznumbers.actions'
import * as contactsActions from '../../_actions/contacts.actions'
import * as smsActions from '../../_actions/sms.actions'
import validate from './validation/smsForm'

// import 'antd/dist/antd.css'

const { Option } = Select
class ModalSMS extends Component {
    state = {
        show: false,
        message: '',
        startDate: new Date(),
        showSchedule: false,
        date14: null,
        value: 1,
        enableReply: true,
        items: [
            {
                label: 'Send Now',
                icon: 'pi pi-check',
                command: e => {
                    this.growl.show({
                        severity: 'success',
                        summary: 'Updated',
                        detail: 'Data Updated',
                    })
                },
            },
            {
                label: 'Scheduled',
                icon: 'pi pi-calendar',
                command: e => {
                    this.growl.show({
                        severity: 'success',
                        summary: 'Delete',
                        detail: 'Data Deleted',
                    })
                },
            },
        ],
    }

    componentDidMount = () => {
        this.props.actions.templatesActions.fetchTemplates()
        this.props.actions.biznumbersActions.fetchBizNumbers()
        this.props.actions.contactsActions.fetchContacts()
    }

    handleClose = () => {
        this.setState({ show: false })
    }

    handleShow = () => {
        this.setState({ show: true })
    }

    handleChange = (value, form) => {
        const tmpObj = _.find(this.props.templates, tmp => {
            return tmp['name'] === value
        })

        form.setFieldValue('message', tmpObj['body'])
        this.setState({ message: tmpObj['body'] })
    }

    handleMessageChanse = (e, form) => {
        form.setFieldValue('message', e.target.value)
        this.setState({ message: e.target.value })
    }

    handleDateChange = date => {
        this.setState({
            startDate: date,
        })
    }

    handleFormSubmit = (values, setSubmitting) => {
        const from = values.from
        const to = _.map(values.to, t => {
            return this.props.contacts[t]
        })

        const biznumber = this.props.biznumbers[`${from}`]
        const data = {
            from: biznumber.name,
            biznumber: biznumber.mobile,
            senderID: biznumber.id,
            contacts: to,
            text: values.message,
            reply: values.reply,
            schedule: values.schedule,
        }

        this.props.actions.smsActions.sendSMS(data).then(res =>
            this.props.handleClose()
        )
        .catch(error => {
            console.log(`error=${error}`)
        })
        .finally(() => {
            setSubmitting(false)
        })
    }

    onChange = (e, form, dateString) => {
        form.setFieldValue('schedule', e.toDate())
    }

    onChkChange = (e, form) => {
        this.setState({ enableReply: e.target.checked })
        // console.log(`checked = ${e.target.checked}`)
    }
    onOk = value => {
        console.log()
    }

    sendOptionChange = e => {
        this.setState({
            value: e.target.value,
        })
    }

    contactsOptions = contacts => {
        if (contacts != undefined) {
            const numbers = _.map(contacts, (obj, key) => {
                return obj
            })

            return _.map(numbers, number => {
                return {
                    label: number.firstName,
                    id: number.id,
                    group: number.group,
                }
            })
        } else {
            return []
        }
    }

    biznumberOptions = biznumbers => {
        if (biznumbers != undefined) {
            const numbers = _.map(biznumbers, (obj, key) => {
                return obj
            })

            return _.map(numbers, number => {
                return { label: number.name, id: number.id }
            })
        } else {
            return []
        }
    }

    render() {
        const templates = _.map(this.props.templates, (obj, key) => {
            return obj
        })

        const templateOptions = _.map(templates, tmp => {
            return { value: tmp.name }
        })

        return (
            <div>
                <Formik
                    initialValues={{
                        to: '',
                        from: '',
                        reply: true,
                        schedule: '',
                        message: ''
                    }}
                    validate={validate()}
                    onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                            this.handleFormSubmit(values, setSubmitting)
                        }, 400)
                    }}
                >
                    {smsForm => (
                        <Form onSubmit={smsForm.handleSubmit}>
                            <div className="row">
                                <div className="col-sm-12 col-md-12">
                                    <div className="panel">
                                        <div className="panel-heading">
                                            <h2 className="panel-title">
                                                Send SMS
                                            </h2>
                                        </div>
                                        <div className="panel-body">
                                            <div className="container-fluid">
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <div className="form-horizontal label-left">
                                                            <div className="col-sm-12 padright20 ">
                                                                <div className="container-fluid">
                                                                    <div className="form-group">
                                                                        <label className="col-xs-2 col-sm-2 col-md-2 control-label">
                                                                            To:{' '}
                                                                        </label>
                                                                        <div className="col-xs-10 col-sm-10 col-md-10">
                                                                            <SelectCompAntd
                                                                                name="to"
                                                                                mode="tags"
                                                                                readOnly={
                                                                                    true
                                                                                }
                                                                                showSearch={
                                                                                    true
                                                                                }
                                                                                placeholder="Enter mobile number or search contacts/list"
                                                                                className="form-control"
                                                                                group={
                                                                                    true
                                                                                }
                                                                                data={this.contactsOptions(
                                                                                    this
                                                                                        .props
                                                                                        .contacts
                                                                                )}
                                                                                maxTagTextLength={
                                                                                    20
                                                                                }
                                                                                maxTagCount={
                                                                                    3
                                                                                }
                                                                                allowClear={
                                                                                    true
                                                                                }
                                                                            ></SelectCompAntd>
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label className="col-xs-2  col-sm-2 col-md-2 control-label ">
                                                                            From:{' '}
                                                                        </label>

                                                                        <div className="col-xs-10 col-sm-10 col-md-10">
                                                                            <SelectCompAntd
                                                                                name="from"
                                                                                style={{
                                                                                    width:
                                                                                        '100%',
                                                                                }}
                                                                                tokenSeparators={[
                                                                                    ',',
                                                                                ]}
                                                                                readOnly={
                                                                                    true
                                                                                }
                                                                                showSearch={
                                                                                    true
                                                                                }
                                                                                placeholder="Enter mobile number or search contacts/list"
                                                                                className="form-control"
                                                                                data={this.biznumberOptions(
                                                                                    this
                                                                                        .props
                                                                                        .biznumbers
                                                                                )}
                                                                                maxTagTextLength={
                                                                                    30
                                                                                }
                                                                                maxTagCount={
                                                                                    5
                                                                                }
                                                                                allowClear={
                                                                                    true
                                                                                }
                                                                            ></SelectCompAntd>
                                                                        </div>

                                                                        <div className="col-xs-1 col-sm-1 col-md-1">
                                                                            <i
                                                                                className="fa fa-info-circle"
                                                                                style={{
                                                                                    paddingLeft:
                                                                                        '10px',
                                                                                }}
                                                                            ></i>
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <div className="col-xs-2  col-sm-2 col-md-2"></div>
                                                                        <div className="col-xs-10 col-sm-10 col-md-10">
                                                                            <Checkbox
                                                                                onChange={e =>
                                                                                    this.onChkChange(
                                                                                        e,
                                                                                        smsForm
                                                                                    )
                                                                                }
                                                                                name="reply"
                                                                                id="reply"
                                                                            >
                                                                                Allow
                                                                                Reply?
                                                                            </Checkbox>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12">
                                                                <div className="container-fluid">
                                                                    <div className="form-group">
                                                                        <label className="col-sm-3 col-md-2 control-label">
                                                                            Message:{' '}
                                                                        </label>
                                                                        <div className="col-sm-9 col-md-10">
                                                                            <textarea
                                                                                className="form-control"
                                                                                placeholder=""
                                                                                rows="5"
                                                                                id="message"
                                                                                type="text"
                                                                                value={
                                                                                    smsForm
                                                                                        .values
                                                                                        .message
                                                                                }
                                                                                maxLength={
                                                                                    160
                                                                                }
                                                                                onChange={e =>
                                                                                    this.handleMessageChanse(
                                                                                        e,
                                                                                        smsForm
                                                                                    )
                                                                                }
                                                                                onBlur={
                                                                                    smsForm.handleBlur
                                                                                }
                                                                            />
                                                                            <p className="help-block ">
                                                                                Approx.
                                                                                12
                                                                                characters/
                                                                                1
                                                                                SMS
                                                                                per
                                                                                recipient
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label className="col-xs-12 col-sm-3 col-md-2 control-label ">
                                                                            Template:{' '}
                                                                        </label>
                                                                        <div className="col-xs-6 col-sm-5 col-md-6">
                                                                            <Select
                                                                                name="period"
                                                                                readOnly
                                                                                placeholder="Select Report Period"
                                                                                className="form-control"
                                                                                defaultValue={
                                                                                    'Choose a template'
                                                                                }
                                                                                onChange={e =>
                                                                                    this.handleChange(
                                                                                        e,
                                                                                        smsForm
                                                                                    )
                                                                                }
                                                                                options={
                                                                                    templateOptions
                                                                                }
                                                                            ></Select>
                                                                        </div>
                                                                        <div className="col-xs-6 col-sm-4 col-md-4">
                                                                            <button
                                                                                className="btn btn-primary pull-right"
                                                                                onClick={
                                                                                    this
                                                                                        .handleShow
                                                                                }
                                                                            >
                                                                                <i className="fa ti-menu-alt "></i>
                                                                                Templates
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12">
                                                                <div className="container-fluid">
                                                                    <div className="form-group">
                                                                        <div className="col-sm-12">
                                                                            <Radio.Group
                                                                                onChange={
                                                                                    this
                                                                                        .sendOptionChange
                                                                                }
                                                                                value={
                                                                                    this
                                                                                        .state
                                                                                        .value
                                                                                }
                                                                            >
                                                                                <Radio
                                                                                    value={
                                                                                        1
                                                                                    }
                                                                                >
                                                                                    Send
                                                                                    Now
                                                                                </Radio>
                                                                                <Radio
                                                                                    value={
                                                                                        2
                                                                                    }
                                                                                >
                                                                                    Schedule
                                                                                </Radio>
                                                                            </Radio.Group>
                                                                        </div>
                                                                        {this
                                                                            .state
                                                                            .value ===
                                                                            2 && (
                                                                            <div className="col-sm-6">
                                                                                <DatePicker
                                                                                    id="schedule"
                                                                                    name="schedule"
                                                                                    showTime
                                                                                    onChange={(
                                                                                        e,
                                                                                        dateString
                                                                                    ) =>
                                                                                        this.onChange(
                                                                                            e,
                                                                                            smsForm,
                                                                                            dateString
                                                                                        )
                                                                                    }
                                                                                    onOk={
                                                                                        this
                                                                                            .onOk
                                                                                    }
                                                                                    placeholder="Select Time"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <div className="row">
                                                            <div className="mobileDevice">
                                                                <div className="mobileDeviceline"></div>
                                                                <div className="screen">
                                                                    <p
                                                                        className="padding5"
                                                                        style={{
                                                                            wordWrap:
                                                                                'break-word',
                                                                        }}
                                                                    >
                                                                        {
                                                                            this
                                                                                .state
                                                                                .message
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel-footer text-right">
                                            <button
                                                type="button"
                                                className="btn btn-default"
                                                data-dismiss="modal"
                                                onClick={this.props.handleClose}
                                            >
                                                <i className="fa fa-times-circle"></i>
                                                Close
                                            </button>
                                            <div
                                                className="btn-group text-left"
                                                style={{ marginLeft: '5px' }}
                                            >
                                                <button
                                                    type="button"
                                                    className="btn btn-primary dropdown-toggle"
                                                    data-toggle="dropdown"
                                                    aria-expanded="false"
                                                    onClick={() => {
                                                        smsForm.submitForm()
                                                    }}
                                                >
                                                    <i className="fa fa-check-circle"></i>
                                                    Send
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <Modal
                                    dialogComponentClass={DraggableModalDialog}
                                    dialogClassName="mod-w650"
                                    show={this.state.show}
                                    onHide={this.handleClose}
                                >
                                    <div>
                                        <div>
                                            <Modal.Header closeButton>
                                                <Modal.Title>
                                                    Templates
                                                </Modal.Title>
                                            </Modal.Header>
                                            <TemplateMng />
                                        </div>
                                    </div>
                                </Modal>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        templates: state.templates.templates,
        biznumbers: state.biznumbers.numbers,
        contacts: state.contacts.contacts,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            templatesActions: bindActionCreators(templatesActions, dispatch),
            biznumbersActions: bindActionCreators(biznumbersActions, dispatch),
            contactsActions: bindActionCreators(contactsActions, dispatch),
            smsActions: bindActionCreators(smsActions, dispatch),
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSMS)
